import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/Mandates/';

export default {
  getMandates: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteMandate: id => del(`${defaultUrl}${id}`),
  saveMandate: data => post(`${defaultUrl}`, data),
};
